import { render } from "./MlcConverter.vue?vue&type=template&id=9cabffda&ts=true"
import script from "./MlcConverter.vue?vue&type=script&lang=ts"
export * from "./MlcConverter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__